export default __webpack_public_path__ + "static/media/facebook.f5cad6e6.svg";